import React from 'react';

export default class TimeController extends React.Component {
    constructor(props) {
        super(props);

        this.interval = null;
    }

    componentDidMount() {
        this.poll();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this.interval = null;
    }

    poll() {
        if(this.props.startTime != null) {
            const now = new Date().getTime();
            const diffInSeconds = Math.floor((now - this.props.startTime) / 1000);
            const diffInMinutes = Math.floor(diffInSeconds / 60);
            if(diffInMinutes >= 15) {
                this.props.onTimeout();
                return;
            }
        }

        this.interval = setInterval(() => {
            if(this.props.startTime == null) {
                return;
            }

            const now = new Date().getTime();
            const diffInSeconds = Math.floor((now - this.props.startTime) / 1000);
            const diffInMinutes = Math.floor(diffInSeconds / 60);

            if(diffInMinutes >= 15) {
                clearInterval(this.interval);
                this.props.onTimeout();
            }
        }, 1000);
    }

    render() {
        return null;
    }
}
